import { render, staticRenderFns } from "./layers-list.vue?vue&type=template&id=1821e538"
import script from "./layers-list.vue?vue&type=script&lang=js"
export * from "./layers-list.vue?vue&type=script&lang=js"
import style0 from "./layers-list.vue?vue&type=style&index=0&id=1821e538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports